/**
 * Moduł obsługujący element "powrot do gory"
 * @type module
 */
app.service('scrollTop', function () {
	var $self;

	function setElements() {
		$self = $('#scroll-top');
	}
	function scrollTop() {
		UA.interaction('Belka', 'Do góry', 'Strzałka');
		$('html, body').animate({
			scrollTop: 0
		}, 500);
	}
	function setEvents() {
		$self.on('click', function (e) {
			e.preventDefault();
			scrollTop();
			$('#header-skip-links li:first-of-type a').focus();
		});
		$self.on('keydown', function (e) { // prevent scrolling when using space
			if ([' '].includes(e.key)) {
				e.preventDefault();
				e.stopPropagation();
			}
		});
		$self.on('keyup', function (e) {
			if ([' '].includes(e.key)) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).trigger('click');
			}
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
